import React, { useState, useEffect } from 'react';
import { 
  Search, Filter, Grid3X3, List, BarChart3, Plus, AlertTriangle,
  Eye, Edit, MoreVertical, Clock, AlertCircle, Monitor, Star,
  CheckCircle, Calendar, Phone, User, DollarSign,
  FileText, Briefcase, BookOpen, Calculator, PenTool,
  ClipboardCheck, Archive, RefreshCw, Hourglass,
  CheckSquare, X, Save, Upload, Users, Building2, UserPlus
} from 'lucide-react';
import { useFormOptions } from '../../../config/constants';
import Select from 'react-select';
import { useListasModel } from '../../../modelos/listas/modeloListas';
import ContenidoEnriquecido from '../../../components/ContenidoEnriquecido';
import { useDetalleSolicitudModel } from '../../../modelos/Solicitudes/modeloSolicitud';
import { useConfiguracion } from '../../../metodos/ConfiguracionContext';
import { useRetornoAsesor } from '../../../config/unificacion';
import ModalAgregarCliente from '../Clientes/addCliente';
import useClientesModel from '../../../modelos/Clientes/modeloClientes';
import CreatableSelect from 'react-select/creatable';
import EditableBoolean from '../../../components/EditableBoolean';

const NuevaSolicitud = ({ isOpen, onClose, isLoading = false }) => {
  const [formData, setFormData] = useState({
    Servicio: '',
    materia: '',
    cliente: '',
    fechaentrega: '',
    resumen: '',
    objetoFaltante: {},
    contenidoEnriquecido: '',
    // Campos de plataforma
    proPlataforma: {
      materia: '',
      fase: '',
      plataforma: '',
      manejoPlataforma: false,
      semestre: '',
      fechaRealUnad: '',
    },
    noVisible: false,
  });

  const [errors, setErrors] = useState({});
  //guardar contenido ENriquecido
  const [contenidoGuardado, setContenidoGuardado] = useState(true); // Nuevo estado
  const [modoEdicion, setModoEdicion] = useState(false); // Nuevo estado
  const [esDeProPlataforma, setEsDeProPlataforma] = useState(false);

  const [modalAgregarClienteOpen, setModalAgregarClienteOpen] = useState(false);

  const {tipoServiciosOptions,materiasTesisListOptions} = useFormOptions();
  const {materiasOptions, cargarMaterias, cargarMateriasPLataforma, materiasPlataformaOptions,
    faseasPlataformaOptions, cargarFasePlataformas,
    cargarPlataformaPlataformas, plataformaPlataformasOptions,
    semestrePlataformaOptions, cargarSemestrePlataformas,
  } = useListasModel();
  const {busquedaClientesOptions,loadingClientes,handleInputChange,addCliente} = useClientesModel();
  const {addNewSolicitud} = useDetalleSolicitudModel();
  const {configuracion, loadingConfiguracion} = useConfiguracion();
  const {retornoAsesor, referidoPor} = useRetornoAsesor();

  //cliente seleccionado
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);

  const resetForm = () => {
  setFormData({
    Servicio: '',
    materia: '',
    cliente: '',
    fechaentrega: '',
    resumen: '',
    objetoFaltante: {},
    contenidoEnriquecido: '',
    proPlataforma: {
      materia: '',
      fase: '',
      plataforma: '',
      manejoPlataforma: false,
      semestre: '',
      fechaRealUnad: '',
      esColaborativo: false,
      tieneForo: false,
    },
    noVisible: false,
    codigoReferenciaCamapa: '',
  });
  setErrors({});
  setContenidoGuardado(true);
  setModoEdicion(false);
  setClienteSeleccionado(null);
  setEsDeProPlataforma(false)
  };

  useEffect(() => {
  if (!isOpen) {
    resetForm();
    return;
  }

  const handleEscapeKey = (event) => {
    if (event.key === 'Escape') {
      onClose();
    }
  };

  document.addEventListener('keydown', handleEscapeKey);

  return () => {
    document.removeEventListener('keydown', handleEscapeKey);
  };
  }, [isOpen, onClose]);

  //cargue utiles
  useEffect(() => {
    //cargar materias
    cargarMaterias();
    //cargar materias pro plataforma
    cargarMateriasPLataforma();
    cargarFasePlataformas();
    cargarPlataformaPlataformas();
    cargarSemestrePlataformas();
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validar que el contenido esté guardado
    if (!contenidoGuardado) {
      setErrors({
        ...errors,
        contenidoEnriquecido: 'Debes guardar el contenido antes de crear la solicitud'
      });
      return;
    }
    
    const nombreEmpresaSubida = configuracion?.servicios_empresas?.[formData.Servicio];
    
    const creadoPor = retornoAsesor();
    const referidoLocalpor = referidoPor(nombreEmpresaSubida);
    formData.referidoPor = referidoLocalpor;
    formData.creadoPor = creadoPor;
    
    try {
      await addNewSolicitud(nombreEmpresaSubida, formData);
      // Limpiar formulario y cerrar modal después del éxito
      resetForm();
      onClose();
    } catch (error) {
      console.error('Error al crear solicitud:', error);
    }
      
  };

  const getOptionFromValue = (options, value) => {
    if (!value || !options || options.length === 0) return null;
    return options.find(option => option.value === value) || null;
  };

  //funciones de select
  const handleSelectChange = (selectedOption, { name }) => {
    setFormData({
      ...formData,
      [name]: selectedOption ? selectedOption.value : ''
    });

    if(name == "cliente"){
      setClienteSeleccionado(selectedOption);
    }
  
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
  };

  const handleSaveContenido = async (nuevoContenido) => {
    try {
      console.log('Guardando contenido:', nuevoContenido);
      
      setFormData(prev => ({
        ...prev,
        contenidoEnriquecido: nuevoContenido
      }));
      
      setContenidoGuardado(true);
      setModoEdicion(false);
      
      // Limpiar error si existe
      if (errors.contenidoEnriquecido) {
        setErrors({
          ...errors,
          contenidoEnriquecido: ''
        });
      }
      
      console.log('Contenido guardado exitosamente');
    } catch (error) {
      console.error('Error al guardar contenido:', error);
      throw error;
    }
  };

  const handleContenidoChange = (editorState) => {
    console.log("Editor state:", editorState);
    
    setModoEdicion(editorState.isEditing);
    setContenidoGuardado(!editorState.hasUnsavedChanges);
    
    console.log("contenido change", editorState.hasUnsavedChanges);
  };


  const getEmpresaInfo = () => {
    if (!formData.Servicio) {
      return {
        type: 'default',
        message: 'Selecciona un servicio para ver la empresa asignada',
        empresa: null
      };
    }
    
    if (configuracion?.servicios_empresas?.[formData.Servicio]) {
      return {
        type: 'success',
        message: 'Empresa asignada',
        empresa: configuracion.servicios_empresas[formData.Servicio]
      };
    }
    
    return {
      type: 'warning',
      message: `Servicio "${formData.Servicio}" no tiene empresa asignada`,
      empresa: null
    };
  };

  const renderCamposDinamicos = () => {
    const servicio = formData.Servicio;
    const objetoFaltante = formData.objetoFaltante || {};

    const handleObjetoFaltanteChange = (field, value) => {
      setFormData(prev => ({
        ...prev,
        objetoFaltante: {
          ...prev.objetoFaltante,
          [field]: value
        }
      }));
    };

    switch (servicio) {
      case 'TALLER':
        return (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Resumen del trabajo *
              </label>
              <textarea
                type="text"
                value={formData.resumen}
                onChange={(e) => setFormData({...formData, resumen: e.target.value})}
                className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.resumen ? 'border-red-500' : 'border-gray-300'}`}
                placeholder="Breve descripción del trabajo a realizar"
                //maxLength={100} ajustar cuando sepamos parametros de wsp
                required
                rows="3"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Formato de Entrega *
              </label>
              <input
                type="text"
                value={objetoFaltante.formatoEntrega || 'No indicado por el cliente / revisar trabajo'}
                onChange={(e) => handleObjetoFaltanteChange('formatoEntrega', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Ej: PDF, Word, Presentación..."
                required
              />
            </div>
          </div>
        );
      
      case 'TESIS':
        return (
          <div className="space-y-4">
            <h4 className="text-md font-medium text-gray-800 border-b pb-2">
              Información de la Tesis
            </h4>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Tema de Tesis *
                </label>
                <input
                  type="text"
                  value={objetoFaltante.temaTesis || ''}
                  onChange={(e) => handleObjetoFaltanteChange('temaTesis', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Título o tema de la tesis"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Carrera *
                </label>
                <input
                  type="text"
                  value={objetoFaltante.carrera || ''}
                  onChange={(e) => handleObjetoFaltanteChange('carrera', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nombre de la carrera"
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Universidad *
                </label>
                <input
                  type="text"
                  value={objetoFaltante.universidad || ''}
                  onChange={(e) => handleObjetoFaltanteChange('universidad', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nombre de la universidad"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Cantidad de Páginas *
                </label>
                <input
                  type="text"
                  value={objetoFaltante.cantidadPaginas || ''}
                  onChange={(e) => handleObjetoFaltanteChange('cantidadPaginas', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Número de páginas"
                  min="1"
                  required
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Normas de Citación *
              </label>
              <input
                type="text"
                value={objetoFaltante.normasCitacion || ''}
                onChange={(e) => handleObjetoFaltanteChange('normasCitacion', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Normas de citación"
                required
              />
            </div>
          </div>
        );
      
      case 'PARCIAL':
      case 'QUIZ':
        return (
          <div className="space-y-4">
            <h4 className="text-md font-medium text-gray-800 border-b pb-2">
              Información del {servicio === 'QUIZ' ? 'Quiz' : 'Parcial'}
            </h4>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Temas del Examen *
              </label>
              <textarea
                value={objetoFaltante.temasExamen || ''}
                onChange={(e) => handleObjetoFaltanteChange('temasExamen', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Describe los temas que incluye el examen"
                rows="3"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Duración del Examen *
              </label>
              <input
                type="text"
                value={objetoFaltante.duracionExamen || ''}
                onChange={(e) => handleObjetoFaltanteChange('duracionExamen', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Ej: 2 horas, 90 minutos, etc."
                required
              />
            </div>
          </div>
        );
      
      case 'CLASES PERSONALIZADAS':
        return (
          <div className="space-y-4">
            <h4 className="text-md font-medium text-gray-800 border-b pb-2">
              Información de las Clases Personalizadas
            </h4>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Temas de clases *
              </label>
              <textarea
                type="text"
                value={formData.resumen}
                onChange={(e) => setFormData({...formData, resumen: e.target.value})}
                className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.resumen ? 'border-red-500' : 'border-gray-300'}`}
                placeholder="Breve descripción de los temas de clase"
                maxLength={100}
                rows="3"
                required
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Número de Horas *
              </label>
              <input
                type="text"
                value={objetoFaltante.numeroHoras || ''}
                onChange={(e) => handleObjetoFaltanteChange('numeroHoras', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Número de horas de clase"
                min="1"
                required
              />
            </div>
          </div>
        );
      
      default:
        return null;
    }
  };

  if (!isOpen) return null;

  const empresaInfo = getEmpresaInfo();

  const handleClienteAgregado = (nuevoCliente) =>{
    console.log("vamos a agregar cliente",nuevoCliente);

    addCliente(configuracion.nombreEmpresa,nuevoCliente);
  };

  //info de cliente
  //info de cliente
  const InfoCliente = ({ clienteSeleccionado }) => {
    // Si no hay cliente seleccionado, no mostramos nada
    if (clienteSeleccionado == null) {
      return null;
    }

    const esProspecto = clienteSeleccionado?.cliente?.nombreCliente === "PROSPECTO" || 
                      clienteSeleccionado?.cliente?.nombreCliente === "PROSPECTO CLIENTE" || 
                      clienteSeleccionado?.cliente?.nombrecompletoCliente === "PROSPECTO CLIENTE";

    return (
      <div className="space-y-3">
        <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <div className="p-1.5 bg-indigo-100 rounded-lg">
            <User size={16} className="text-indigo-600" />
          </div>
          Información del Cliente
        </h3>
        
        {esProspecto ? (
        <div className="p-4 rounded-lg border-l-4 bg-red-50 border-red-400">
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 rounded-full bg-red-100">
              <AlertTriangle size={16} className="text-red-600" />
            </div>
            <div>
              <h4 className="text-base font-bold text-red-900">Cliente Prospecto</h4>
              <p className="text-xs text-red-700">
                Cliente no registrado completamente
              </p>
            </div>
          </div>
          <div className="bg-red-100 rounded-lg p-3">
            <p className="text-red-800 text-xs">
              <strong>Nota:</strong> Considera actualizar los datos después de crear la solicitud.
            </p>
          </div>
        </div>
        ) : (
          // ✅ DISEÑO MEJORADO PARA CLIENTE REGISTRADO
          (() => {
            // Variable para verificar si faltan datos clave
            const datosIncompletos = 
              !clienteSeleccionado.cliente?.universidad || clienteSeleccionado.cliente.universidad === 'NO REGISTRADO' ||
              !clienteSeleccionado.cliente?.carrera || clienteSeleccionado.cliente.carrera === 'NO REGISTRADO';

            return (
              <div className="p-4 rounded-lg border-l-4 bg-green-50 border-green-400">
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-2 rounded-full bg-green-100">
                    <CheckCircle size={16} className="text-green-600" />
                  </div>
                  <div>
                    <h4 className="text-base font-bold text-green-900">Cliente Registrado</h4>
                  </div>
                </div>
                
                {/* --- ⚠️ NUEVO BLOQUE DE ALERTA VISIBLE --- */}
                {datosIncompletos && (
                  <div className="mb-4 p-3 rounded-lg border bg-yellow-50 border-yellow-300 flex items-start gap-3">
                    <AlertTriangle size={20} className="text-yellow-600 mt-0.5" />
                    <div>
                      <h5 className="font-bold text-yellow-800">Acción Requerida</h5>
                      <p className="text-xs text-yellow-700">
                        Es necesario actualizar la <strong>universidad y/o carrera</strong> del cliente si esto es posible.
                      </p>
                    </div>
                  </div>
                )}

                {/* Información en formato compacto */}
                <div className="space-y-3">
                  {/* Información Personal */}
                  <div>
                    <h5 className="text-sm font-semibold text-green-800 mb-2">Información Personal</h5>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-xs">
                      <div>
                        <span className="font-medium text-green-600">Nombre:</span>
                        <p className="text-green-900 truncate">{clienteSeleccionado.cliente?.nombrecompletoCliente || 'No registrado'}</p>
                      </div>
                      <div>
                        <span className="font-medium text-green-600">Cliente #:</span>
                        <p className="text-green-900">{clienteSeleccionado.cliente?.numero || 'No asignado'}</p>
                      </div>
                      <div>
                        <span className="font-medium text-green-600">Email:</span>
                        <p className="text-green-900 truncate">{clienteSeleccionado.cliente?.correoElectronico || 'No registrado'}</p>
                      </div>
                    </div>
                  </div>

                  {/* Información Académica */}
                  <div>
                    <h5 className="text-sm font-semibold text-green-800 mb-2">Información Académica</h5>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-xs">
                      <div>
                        <span className="font-medium text-green-600">Universidad:</span>
                        <p className={`truncate ${(!clienteSeleccionado.cliente?.universidad || clienteSeleccionado.cliente.universidad === 'NO REGISTRADO') ? 'text-red-600 font-bold' : 'text-green-900'}`}>
                          {(!clienteSeleccionado.cliente?.universidad || clienteSeleccionado.cliente.universidad === 'NO REGISTRADO') ? '⚠️ Actualizar' : clienteSeleccionado.cliente.universidad}
                        </p>
                      </div>
                      <div>
                        <span className="font-medium text-green-600">Carrera:</span>
                        <p className={`truncate ${(!clienteSeleccionado.cliente?.carrera || clienteSeleccionado.cliente.carrera === 'NO REGISTRADO') ? 'text-red-600 font-bold' : 'text-green-900'}`}>
                          {(!clienteSeleccionado.cliente?.carrera || clienteSeleccionado.cliente.carrera === 'NO REGISTRADO') ? '⚠️ Actualizar' : clienteSeleccionado.cliente.carrera}
                        </p>
                      </div>
                      <div>
                        <span className="font-medium text-green-600">Procedencia:</span>
                        <p className="text-green-900">{clienteSeleccionado.cliente?.procedencia || 'No registrado'}</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Cliente Especial UNAD */}
                {clienteSeleccionado.cliente?.clienteEspecialPlataformaUNAD && (
                  <div className="mt-3 pt-3 border-t border-green-200">
                    <div className="bg-blue-100 border border-blue-200 rounded-lg p-2 flex items-center gap-2">
                      <Star size={14} className="text-blue-600" />
                      <span className="text-blue-800 text-xs font-medium">Cliente Especial Plataforma UNAD</span>
                    </div>
                  </div>
                )}
              </div>
            );
          })()
        )}
      </div>
    );
  };
  //campos pro plataforma
  const CamposProPlataforma = () => {
   // if (!esDeProPlataforma) return null;
    const proPlataforma = formData.proPlataforma || {};

    
    const handleProPlataforma = (field, value) => {
      console.log('🔧 Actualizando:', field, '=', value);
      setFormData(prev => {
        console.log('🔧 Estado anterior:', prev.proPlataforma);
        const newState = {
          ...prev,
          proPlataforma: {
            ...prev.proPlataforma,
            [field]: value
          }
        };
        console.log('🔧 Estado nuevo:', newState.proPlataforma);
        return newState;
      });
    };

    return (
      <div className="space-y-4">
        {/* --- ENCABEZADO --- */}
        <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <div className="p-1.5 bg-indigo-100 rounded-lg">
            <Monitor size={16} className="text-indigo-600" />
          </div>
          Información de Plataforma
        </h3>

        {/* --- CONTENEDOR DE CAMPOS --- */}
        <div className="p-6 bg-indigo-50 rounded-lg border border-indigo-200">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5">

            {/* --- Materia de plataforma --- */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Materia de Plataforma *
              </label>
              <CreatableSelect
                value={proPlataforma.materia ? { label: proPlataforma.materia, value: proPlataforma.materia } : null}
                onChange={(selectedOption) => handleProPlataforma('materia', selectedOption ? selectedOption.value : '')}
                options={materiasPlataformaOptions}
                placeholder="Seleccione o cree una materia"
                isClearable
                isSearchable
                classNamePrefix="react-select"
              />
            </div>

            {/* --- Fase de plataforma --- */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Fase *
              </label>
              <CreatableSelect
                value={proPlataforma.fase ? { label: proPlataforma.fase, value: proPlataforma.fase } : null}
                onChange={(selectedOption) => handleProPlataforma('fase', selectedOption ? selectedOption.value : '')}
                options={faseasPlataformaOptions}
                placeholder="Seleccione o cree una fase"
                isClearable
                isSearchable
                classNamePrefix="react-select"
              />
            </div>

             {/* --- Plataforma de plataforma --- */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Plataforma *
              </label>
              <CreatableSelect
                value={proPlataforma.plataforma ? { label: proPlataforma.plataforma, value: proPlataforma.plataforma } : null}
                onChange={(selectedOption) => handleProPlataforma('plataforma', selectedOption ? selectedOption.value : '')}
                options={plataformaPlataformasOptions}
                placeholder="Seleccione o cree una plataforma"
                isClearable
                isSearchable
                classNamePrefix="react-select"
              />
            </div>

            {/* --- Es colaborativo ? --- */}
            <EditableBoolean
              label="Es colaborativo? *"
                value={proPlataforma.esColaborativo}
                onChange={(newValue) => handleProPlataforma('esColaborativo', newValue)}
            />

            {/* --- Tiene foro? --- */}
            <EditableBoolean
              label="Es tieneForo? *"
                value={proPlataforma.tieneForo}
                onChange={(newValue) => handleProPlataforma('tieneForo', newValue)}
            />

            {/* --- Plataforma de plataforma --- */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Semestre *
              </label>
              <CreatableSelect
                value={proPlataforma.semestre ? { label: proPlataforma.semestre, value: proPlataforma.semestre } : null}
                onChange={(selectedOption) => handleProPlataforma('semestre', selectedOption ? selectedOption.value : '')}
                options={semestrePlataformaOptions}
                placeholder="Seleccione un semestre"
                isClearable
                isSearchable
                classNamePrefix="react-select"
              />
            </div>

            {/* --- Fecha limite de la UNAD --- */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Fecha Límite (UNAD) *
              </label>
              <input
                type="datetime-local"
                value={proPlataforma.fechaRealUnad}
                onChange={(e) => handleProPlataforma('fechaRealUnad', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-sm"
              />
            </div>

            {/* --- Manejo de plataforma --- */}
             <EditableBoolean
              label="¿Quién maneja la plataforma? *"
                value={proPlataforma.manejoPlataforma}
                onChange={(newValue) => handleProPlataforma('manejoPlataforma', newValue)}
                falseLabel="Cliente"
                trueLabel="Nosotros"
            />
            
          </div>
        </div>
      </div>
    );

  };

  const getMateriaOptions = () => {
    // Si no hay servicio seleccionado, retornar array vacío
    if (!formData.Servicio) {
      return [];
    }
    
    // Si el servicio es TESIS, retornar materiasTesisListOptions
    if (formData.Servicio === 'TESIS') {
      return materiasTesisListOptions || [];
    }
    
    // Para cualquier otro servicio, retornar materiasOptions
    return materiasOptions || [];
  };

  return (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl max-h-[90vh] overflow-y-auto">
      
      <ModalAgregarCliente 
        isOpen={modalAgregarClienteOpen}
        onClose={() => setModalAgregarClienteOpen(false)}
        onClienteAgregado={handleClienteAgregado}
      />
      
      {/* Header */}
      <div className="sticky top-0 bg-white border-b border-gray-200 px-8 py-6 flex items-center justify-between rounded-t-xl">
        <div className="flex items-center gap-4">
          <div className="p-3 bg-blue-100 rounded-lg">
            <Plus size={24} className="text-blue-600" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-gray-900">Nueva Solicitud</h2>
            <p className="text-sm text-gray-600">Completa la información del servicio requerido</p>
          </div>
        </div>
        <button
          onClick={onClose}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <X size={20} />
        </button>
      </div>

      {/* Form */}
      <form onSubmit={handleSubmit} className="p-8 space-y-8">
        {/* Información del Servicio */}
        <div className="space-y-6">
          <h3 className="text-xl font-semibold text-gray-900 flex items-center gap-3">
            <div className="p-2 bg-blue-100 rounded-lg">
              <Briefcase size={20} className="text-blue-600" />
            </div>
            Información del Servicio
          </h3>

          {/* Card de empresa asignada */}
          <div className={`p-6 rounded-xl border-l-4 ${
            empresaInfo.type === 'success' 
              ? 'bg-green-50 border-green-400' 
              : empresaInfo.type === 'warning'
              ? 'bg-orange-50 border-orange-400'
              : 'bg-blue-50 border-blue-400'
          }`}>
            <div className="flex items-center gap-4">
              <div className={`p-3 rounded-full ${
                empresaInfo.type === 'success' 
                  ? 'bg-green-100' 
                  : empresaInfo.type === 'warning'
                  ? 'bg-orange-100'
                  : 'bg-blue-100'
              }`}>
                <Building2 size={20} className={
                  empresaInfo.type === 'success' 
                    ? 'text-green-600' 
                    : empresaInfo.type === 'warning'
                    ? 'text-orange-600'
                    : 'text-blue-600'
                } />
              </div>
              <div>
                <p className={`text-sm font-medium ${
                  empresaInfo.type === 'success' 
                    ? 'text-green-800' 
                    : empresaInfo.type === 'warning'
                    ? 'text-orange-800'
                    : 'text-blue-800'
                }`}>
                  {empresaInfo.message}
                </p>
                {empresaInfo.empresa && (
                  <p className={`text-lg font-bold ${
                    empresaInfo.type === 'success' 
                      ? 'text-green-900' 
                      : 'text-orange-900'
                  }`}>
                    {empresaInfo.empresa}
                  </p>
                )}
              </div>
            </div>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-3">
                Tipo de Servicio *
              </label>
              <Select
                name="Servicio"
                value={getOptionFromValue(tipoServiciosOptions, formData.Servicio)}
                onChange={handleSelectChange}
                options={tipoServiciosOptions}
                placeholder="Selecciona el tipo de servicio"
                isClearable
                isSearchable
                classNamePrefix="react-select"
                required
              />
              {errors.Servicio && <p className="text-red-500 text-sm mt-2">{errors.Servicio}</p>}
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-3">
                Materia *
              </label>
              <Select
                name="materia"
                value={getOptionFromValue(getMateriaOptions(), formData.materia)}
                onChange={handleSelectChange}
                options={getMateriaOptions()}
                placeholder="Selecciona la materia"
                isClearable
                isSearchable
                classNamePrefix="react-select"
                required
              />
              {errors.materia && <p className="text-red-500 text-sm mt-2">{errors.materia}</p>}
            </div>
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Cliente
            </label>
            <div className="flex gap-4">
              <div className="flex-1">
                <Select
                  name="cliente"
                  value={getOptionFromValue(busquedaClientesOptions, formData.cliente)}
                  onChange={handleSelectChange}
                  onInputChange={handleInputChange}
                  options={busquedaClientesOptions}
                  placeholder="Selecciona el cliente"
                  isClearable
                  isSearchable
                  isLoading={loadingClientes}
                  loadingMessage={() => "Cargando clientes..."}
                  noOptionsMessage={() => "No se encontraron clientes"}
                  classNamePrefix="react-select"
                  className="react-select-container"
                />
              </div>
              <button
                type="button"
                onClick={() => setModalAgregarClienteOpen(true)}
                className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center gap-2 whitespace-nowrap font-medium"
                title="Agregar nuevo cliente"
              >
                <UserPlus size={18} />
                Agregar
              </button>
            </div>
          </div>
        </div>

        {/* Informacion del cliente */}
        <InfoCliente clienteSeleccionado={clienteSeleccionado}/>
        
        {/* Servicio proPlataforma */}
        {/* Checkbox Es de Plataforma */}
        <div className="space-y-3">
          <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg border border-gray-200">
            <input
              type="checkbox"
              id="esDeProPlataforma"
              checked={esDeProPlataforma} // ← USAR estado separado
              onChange={(e) => {
                const isChecked = e.target.checked;
                setEsDeProPlataforma(isChecked);
                
                // Si se desmarca, resetear todos los campos de proPlataforma
                if (!isChecked) {
                  setFormData(prev => ({
                    ...prev,
                    proPlataforma: {
                      materia: '',
                      fase: '',
                      plataforma: '',
                      manejoPlataforma: false,
                      semestre: ''
                    }
                  }));
                }
              }}
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
            />
            <label htmlFor="esDeProPlataforma" className="text-base font-medium text-gray-900 cursor-pointer">
              ¿Es un servicio de plataforma educativa?
            </label>
          </div>
        </div>

        {/* Campos de Plataforma */}
        {esDeProPlataforma&& (
            <div className="p-6 bg-gray-50 rounded-lg border border-gray-200">
              {CamposProPlataforma()}
            </div>
          )}
        

        {/* Fecha y Hora de Entrega */}
        <div className="space-y-6">
          <h3 className="text-xl font-semibold text-gray-900 flex items-center gap-3">
            <div className="p-2 bg-purple-100 rounded-lg">
              <Calendar size={20} className="text-purple-600" />
            </div>
            Fecha y Hora de Entrega
          </h3>
          
          <div className="max-w-md">
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Fecha de Entrega *
            </label>
            <input
              type="datetime-local"
              value={formData.fechaentrega}
              onChange={(e) => setFormData({...formData, fechaentrega: e.target.value})}
              min={new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().slice(0, 16)}
              className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                errors.fechaentrega ? 'border-red-500' : 'border-gray-300'
              }`}
              required
            />
            {errors.fechaentrega && <p className="text-red-500 text-sm mt-2">{errors.fechaentrega}</p>}
          </div>
        </div>

        {/* Descripción del trabajo */}
        <div className="space-y-6">
          <h3 className="text-xl font-semibold text-gray-900 flex items-center gap-3">
            <div className="p-2 bg-orange-100 rounded-lg">
              <FileText size={20} className="text-orange-600" />
            </div>
            Descripción del Trabajo
          </h3>

          {formData.Servicio && (
            <div className="p-6 bg-gray-50 rounded-lg border border-gray-200">
              {renderCamposDinamicos()}
            </div>
          )}

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Descripción Detallada *
            </label>
            
            {/* Alerta si el contenido no está guardado */}
            {!contenidoGuardado && (
              <div className="mb-4 p-4 bg-yellow-50 border border-yellow-200 rounded-lg flex items-center gap-3">
                <AlertCircle size={20} className="text-yellow-600" />
                <p className="text-yellow-800 text-sm font-medium">
                  Tienes cambios sin guardar. Debes guardar el contenido antes de crear la solicitud.
                </p>
              </div>
            )}

            <div className="mb-6">
              <ContenidoEnriquecido 
                contenido={formData.contenidoEnriquecido} 
                isAdmin={true}
                editable={true}
                onSave={handleSaveContenido}
                onChange={handleContenidoChange}
              />
            </div>

            {errors.contenidoEnriquecido && (
              <p className="text-red-500 text-sm mt-2">{errors.contenidoEnriquecido}</p>
            )}
          </div>
        </div>

        {/* Opciones adicionales */}
        <div className="space-y-6">
          <h3 className="text-xl font-semibold text-gray-900 flex items-center gap-3">
            <div className="p-2 bg-slate-100 rounded-lg">
              <AlertTriangle size={20} className="text-slate-600" />
            </div>
            Opciones Adicionales
          </h3>

          {/* Codigo de Referencia */}
          <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Codigo de Referencia *
              </label>
              <input
                type="text"
                value={formData.codigoReferenciaCamapa || ''}
                onChange={(e) => setFormData({...formData, codigoReferenciaCamapa: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Codigo de referencia de llegada"
              />
          </div>
          
          {/* Boton de no notificar */}
          <div className="p-4 bg-yellow-50 rounded-lg border border-yellow-200">
            <div className="flex items-center gap-4">
              <input
                type="checkbox"
                id="noVisible"
                checked={formData.noVisible}
                onChange={(e) => setFormData({ ...formData, noVisible: e.target.checked })}
                className="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer"
              />
              <div>
                <label htmlFor="noVisible" className="font-medium text-gray-900 cursor-pointer">
                  Marcar como no visible
                </label>
                <p className="text-sm text-gray-600">
                  Si se marca, esta solicitud no será visible en listados generales para otros tutores ni sera notificada.
                </p>
              </div>
            </div>
          </div>

        </div>


        {/* Botones */}
        <div className="flex flex-col sm:flex-row gap-4 pt-8 border-t border-gray-200">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 bg-gray-100 text-gray-700 px-8 py-4 rounded-lg hover:bg-gray-200 transition-colors font-medium"
          >
            Cancelar
          </button>
          
          <button
            type="submit"
            disabled={isLoading || !contenidoGuardado}
            className="flex-1 bg-blue-600 text-white px-8 py-4 rounded-lg hover:bg-blue-700 transition-colors font-medium flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                Creando...
              </>
            ) : (
              <>
                <Save size={18} />
                Crear Solicitud
              </>
            )}
          </button>
        </div>
      </form>
      
    </div>
  </div>
  );

};

export default NuevaSolicitud;